<mat-button-toggle-group
	style="border-radius: var(--radius-sgnl-border-radius-6); border-color:  var(--defaults-primary-border-primary); height: 28px"
	[hideSingleSelectionIndicator]="true"
	[formControl]="buttonGroup"
>
	@if (privateOptionsArray) {
		@if (privateOptionsArray.length > 0) {
			@for (option of privateOptionsArray; track option.value) {
				@if (option.icon) {
					<mat-button-toggle [disabled]="disabled" [value]="option.value">
						<lib-icon
							[color]="buttonGroup.value === option.value ? '307D2B' : '307D2B'"
							[icon]="option.icon"
							[size]="{ width: '28px', height: '28px' }"
						></lib-icon>
					</mat-button-toggle>
				} @else {
					<mat-button-toggle [value]="option.value">{{ option.value | titlecase }}</mat-button-toggle>
				}
			}
		}
	}
</mat-button-toggle-group>
